
import { Packages } from './packages';
import { Attachments } from './attachments';

export class RequestMaterial {

    
    private _pkgs: Packages[];
    private _attachments: Attachments[];
    private _model : any;
    constructor(private _modelDefined: any) {
        this._model = this._modelDefined ? angular.copy(this._modelDefined) : {};
        this.loadAttachments();
        this.loadPackages();
    }

    private loadPackages(): void {
        
        if (this._model !== undefined && this._model.requestPackages !== undefined && this._model.requestPackages.length > 0) {
            this._pkgs = [];
            for (let pkg of this._model.requestPackages) {
                this._pkgs.push(new Packages(pkg));
            }
        } 
    }

    private loadAttachments(): void {
        if (this._model !== undefined &&  this._model.requestAttachments !== undefined && this._model.requestAttachments.length > 0) {
            this._attachments = [];
            for (let attachment of this._model.requestAttachments) {
                this._attachments.push(new Attachments(attachment));
            }
        } 
    }

    get requestPackages() : Packages[] {

        return this._pkgs;
    }

    set requestPackages(val: Packages[]) {
        this._pkgs = [];
        for (let pkg of val) {
            this._pkgs.push(new Packages(pkg));
        }
    }

    get requestAttachments(): Attachments[] {
        return this._attachments;
    }

    set requestAttachments(val: Attachments[]) {
        this._attachments = [];
        for (let attachment of val) {
            this._attachments.push(new Attachments(attachment));
        }
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/models/requestMaterial.ts
 **/